module.exports = __webpack_public_path__ + "img/car-side-bolt.c77054bb.svg";